module.exports = __webpack_public_path__ + "static/key-company-28e84011b30d8ad89a46c80553e678d3.webp";